import { DynamicField, fromSnakeToTitleCase } from '@evertrue/sdk';
import DateInput from 'components/forms/dynamic-form-inputs/date-input';
import NumberInput from 'components/forms/dynamic-form-inputs/number-input';
import PropTypes from 'prop-types';

const AmountField = ({ name = '', label = '', values = {} }) => {
  const titleName = fromSnakeToTitleCase(label);
  return (
    <div className="form-row">
      <DynamicField name={`${name}_date`} label={titleName} values={values} as={DateInput} />
      <DynamicField
        name={`${name}_amount`}
        label={titleName}
        values={values}
        as={NumberInput}
        showIcon
        maskType="currency"
        integerLimit={10}
        placeholder={`${titleName} Dollars`}
      />
      {name === 'expected' && (
        <DynamicField
          name="confidence_score"
          label="Confidence"
          values={values}
          as={NumberInput}
          showIcon
          maskType="percent"
          valueLimit={100}
          integerLimit={3}
        />
      )}
    </div>
  );
};

AmountField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
};

export default AmountField;
